export type Permission =
  | 'dashboard.view'
  | 'dashboard.owner'
  | 'dashboard.finance'
  | 'dashboard.hr'
  | 'dashboard.sales'
  | 'dashboard.pos'
  | 'khata.view'
  | 'khata.create'
  | 'expenses.view'
  | 'expenses.create'
  | 'reports.view'
  | 'invoices.view'
  | 'invoices.create'
  | 'pos.access'
  | 'hr.view'
  | 'hr.manage'
  | 'self.work'
  | 'attendance.view'
  | 'leaves.manage'
  | 'payroll.manage'
  | 'inventory.view'
  | 'inventory.edit'
  | 'purchase.view'
  | 'purchase.approve'
  | 'banking.view'
  | 'banking.manage'
  | 'projects.view'
  | 'settings.view'
  | 'settings.manage'
  | 'team.manage'
  | 'partners.view';

export const ROLE_PERMISSIONS: Record<number, Array<Permission | '*'>> = {
  0: ['*'], // SuperAdmin
  5: ['*'], // Owner
  1: [ // Admin
    'dashboard.owner',
    'self.work',
    'khata.view',
    'khata.create',
    'expenses.view',
    'expenses.create',
    'invoices.view',
    'invoices.create',
    'pos.access',
    'inventory.view',
    'inventory.edit',
    'purchase.view',
    'hr.view',
    'hr.manage',
    'attendance.view',
    'leaves.manage',
    'payroll.manage',
    'partners.view',
    'projects.view',
    'reports.view',
    'settings.view',
    'settings.manage',
    'team.manage',
    'purchase.approve',
    'banking.view',
    'banking.manage'
  ],

  2: [ // Accountant
    'dashboard.finance',
    'self.work',
    'khata.view',
    'expenses.view',
    'expenses.create',
    'reports.view',
    'banking.view'
  ],

  3: [ // Sales
    'dashboard.sales',
    'self.work',
    'pos.access',
    'inventory.view',
    'invoices.view',
    'invoices.create',
    'partners.view'
  ],

  4: [ // POS Operator
    'dashboard.pos',
    'self.work',
    'pos.access'
  ],

  6: [ // HR Manager
    'dashboard.hr',
    'self.work',
    'hr.view',
    'hr.manage',
    'attendance.view',
    'leaves.manage',
    'payroll.manage',
    'settings.view',
    'team.manage'
  ]
};
